import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {OrderInstoreItemResult} from "@/models";

export class InstoreOrderService {
    private baseApiFactory: BaseApiFactory;

    static $inject = ['BaseApiFactory'];

    constructor(baseApiFactory: BaseApiFactory) {
        this.baseApiFactory = baseApiFactory;
    }

    getOrders(query: object, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<OrderInstoreItemResult[]>('/v2/api/InstoreOrder/list-by-status', query, cancelToken);
    }

    releaseOrder(number: string, postData: object, cancelToken?: AbortSignal) {
        return this.baseApiFactory.put<boolean>(`/api/InstoreOrder/${number}`, postData, cancelToken);
    }

    createActiveCode(cancelToken?: AbortSignal) {
        return this.baseApiFactory.post<string>('/v2/api/InstoreOrder/create-active-code', {}, cancelToken);
    }
}

lazyRegister.service('InstoreOrderService', InstoreOrderService);
